enum PatternId {
  A3 = '3A',
  A4 = '4A',
  B4 = '4B',
  A5 = '5A',
  A6 = '6A',
  B6 = '6B',
  D6 = '6D',
  A7 = '7A',
  A8 = '8A',
  C8 = '8C',
  D8 = '8D',
  A9 = '9A',
  B9 = '9B',
  D9 = '9D',
  A10 = '10A',
  C10 = '10C',
  J10 = '10J',
  A11 = '11A',
  A12 = '12A',
  B12 = '12B',
  A13 = '13A',
  B13 = '13B',
  A14 = '14A',
  A15 = '15A',
  D16 = '16D',
  A18 = '18A',
  C20 = '20C',
  GRID = 'Grid',
}

export default PatternId;
